import { render, staticRenderFns } from "./ReportarPartidaEditar.vue?vue&type=template&id=c29369d6&scoped=true&"
import script from "./ReportarPartidaEditar.vue?vue&type=script&lang=js&"
export * from "./ReportarPartidaEditar.vue?vue&type=script&lang=js&"
import style0 from "./ReportarPartidaEditar.vue?vue&type=style&index=0&id=c29369d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29369d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VForm,VIcon,VImg,VRow})
